import React from "react";
import { Link } from "react-router-dom";

const PROMISES = [
  { icon: "bi-patch-check", title: "100% chính hãng", desc: "Nhập khẩu chính ngạch, đủ hóa đơn" },
  { icon: "bi-truck", title: "Miễn phí giao hàng", desc: "Cho đơn từ 499K toàn quốc" },
  { icon: "bi-arrow-repeat", title: "Đổi trả trong 7 ngày", desc: "Hoàn tiền 100% nếu lỗi" },
  { icon: "bi-headset", title: "Tư vấn tận tâm", desc: "0967.711.633 (8h–18h)" },
];

const COLUMNS = [
  {
    title: "Về HealthyMall",
    links: [
      { label: "Về chúng tôi", to: "/trang/ve-chung-toi" },
      { label: "Giới thiệu", to: "/trang/gioi-thieu" },
      { label: "Đội ngũ chuyên gia", to: "/tac-gia" },
      { label: "Góc sức khỏe", to: "/bai-viet" },
      { label: "Giấy phép kinh doanh", to: "/trang/giay-phep-kinh-doanh" },
    ],
  },
  {
    title: "Danh mục",
    links: [
      { label: "Mẹ bầu", to: "/danh-muc/me-bau" },
      { label: "Mẹ và bé", to: "/danh-muc/me-va-be" },
      { label: "Dành cho trẻ nhỏ", to: "/danh-muc/danh-cho-tre-nho" },
      { label: "Dành cho phụ nữ", to: "/danh-muc/danh-cho-phu-nu" },
      { label: "Dành cho nam giới", to: "/danh-muc/danh-cho-nam-gioi" },
      { label: "Mỹ phẩm", to: "/danh-muc/my-pham" },
    ],
  },
  {
    title: "Hỗ trợ khách hàng",
    links: [
      { label: "Câu hỏi thường gặp", to: "/cau-hoi-thuong-gap" },
      { label: "Chính sách đổi trả", to: "/trang/chinh-sach-doi-tra" },
      { label: "Chính sách giao hàng", to: "/trang/chinh-sach-giao-hang" },
      { label: "Chính sách thanh toán", to: "/trang/chinh-sach-thanh-toan" },
      { label: "Chính sách nhà phân phối", to: "/trang/chinh-sach-nha-phan-phoi" },
      { label: "Liên hệ", to: "/lien-he" },
    ],
  },
];

const SOCIALS = [
  { href: "https://www.facebook.com/HealthyMall.Vn", icon: "/facebook.svg", label: "Facebook" },
  { href: "https://www.tiktok.com/@healthyaussie", icon: "/tiktok.svg", label: "TikTok" },
  { href: "https://zalo.me/0967711633", icon: "/zalo.svg", label: "Zalo" },
];

const PAYMENTS = [
  { src: "/cod.webp", label: "Thanh toán khi nhận hàng" },
  { src: "/atm.webp", label: "Chuyển khoản ngân hàng" },
  { src: "/momo.webp", label: "Ví MoMo" },
  { src: "/visa.webp", label: "Thẻ Visa" },
];

const Footer = () => (
  <footer className="mt-12 border-t border-slate-200 bg-white">
    {/* Cam kết */}
    <div className="border-b border-slate-100 bg-brand-50/60">
      <ul className="container-hm m-0 grid list-none grid-cols-1 gap-x-4 gap-y-4 py-6 sm:grid-cols-2 lg:grid-cols-4">
        {PROMISES.map((p) => (
          <li key={p.title} className="flex list-none items-center gap-3">
            <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-white text-xl text-brand-600 ring-1 ring-brand-100">
              <i className={`bi ${p.icon}`} aria-hidden="true" />
            </span>
            <span className="min-w-0 leading-tight">
              <span className="block text-base font-semibold text-slate-900">{p.title}</span>
              <span className="block text-sm text-slate-500">{p.desc}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>

    {/* Nội dung chính */}
    <div className="container-hm grid grid-cols-2 gap-x-6 gap-y-8 py-10 md:grid-cols-4 lg:grid-cols-12">
      <div className="col-span-2 md:col-span-4 lg:col-span-3">
        <Link to="/" className="inline-flex rounded-full bg-brand-600 px-4 py-2.5" aria-label="HealthyMall — Trang chủ">
          <img src="/logo.webp" width={150} height={24} alt="HealthyMall" loading="lazy" className="h-auto w-[150px]" />
        </Link>
        <p className="m-0 mt-4 max-w-sm text-base leading-relaxed text-slate-600">
          Trang mua sắm chuyên thực phẩm chức năng nhập khẩu chính hãng — phân phối độc quyền thương hiệu Perdays (Úc) cùng nhiều thương hiệu uy tín quốc tế.
        </p>
        <div className="mt-4 flex items-center gap-2">
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              aria-label={s.label}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 transition-colors hover:bg-brand-100"
            >
              <img src={s.icon} width={18} height={18} alt="" />
            </a>
          ))}
        </div>
      </div>

      {COLUMNS.map((col) => (
        <nav key={col.title} aria-label={col.title} className="lg:col-span-2">
          <h2 className="m-0 mb-3 text-base font-semibold text-slate-900">{col.title}</h2>
          <ul className="m-0 flex list-none flex-col gap-2.5 p-0">
            {col.links.map((l) => (
              <li key={l.to} className="list-none">
                <Link to={l.to} className="text-base text-slate-600 no-underline transition-colors hover:text-brand-700">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}

      <div className="col-span-2 md:col-span-1 lg:col-span-3">
        <h2 className="m-0 mb-3 text-base font-semibold text-slate-900">Liên hệ</h2>
        <ul className="m-0 flex list-none flex-col gap-3 p-0 text-base text-slate-600">
          <li className="flex list-none items-start gap-2">
            <i className="bi bi-telephone mt-0.5 text-brand-600" aria-hidden="true" />
            <a href="tel:+84967711633" className="font-semibold text-slate-900 no-underline hover:text-brand-700">
              0967.711.633
            </a>
          </li>
          <li className="flex list-none items-start gap-2">
            <i className="bi bi-envelope mt-0.5 text-brand-600" aria-hidden="true" />
            <a href="mailto:HealthyMall.Vn@gmail.com" className="break-all text-slate-600 no-underline hover:text-brand-700">
              HealthyMall.Vn@gmail.com
            </a>
          </li>
          <li className="flex list-none items-start gap-2">
            <i className="bi bi-geo-alt mt-0.5 text-brand-600" aria-hidden="true" />
            <span className="leading-snug">72A Nguyễn Trãi, P. Thượng Đình, Q. Thanh Xuân, Hà Nội</span>
          </li>
        </ul>
        <img src="/qrcode.svg" alt="Mã QR healthymall.vn" width={88} height={88} loading="lazy" className="mt-4 hidden rounded-lg ring-1 ring-slate-200 lg:block" />
      </div>
    </div>

    {/* Thanh toán + khuyến cáo */}
    <div className="border-t border-slate-100">
      <div className="container-hm flex flex-col gap-4 py-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <span className="mr-1 text-sm font-medium text-slate-500">Thanh toán:</span>
          {PAYMENTS.map((p) => (
            <span key={p.src} className="flex h-10 items-center rounded-lg bg-white px-2.5 ring-1 ring-slate-200" title={p.label}>
              <img src={p.src} alt={p.label} height={28} width={44} loading="lazy" className="h-7 w-auto object-contain" />
            </span>
          ))}
        </div>
        <p className="m-0 flex max-w-2xl items-start gap-2 text-sm leading-relaxed text-slate-500">
          <i className="bi bi-info-circle mt-0.5" aria-hidden="true" />
          Thực phẩm này không phải là thuốc và không có tác dụng thay thế thuốc chữa bệnh. Hiệu quả của sản phẩm có thể thay đổi tùy theo cơ địa mỗi người.
        </p>
      </div>
    </div>

    <div className="border-t border-slate-100 bg-slate-50">
      <div className="container-hm flex flex-col items-center justify-between gap-2 py-4 text-sm text-slate-500 sm:flex-row">
        <p className="m-0 text-center sm:text-left">© {new Date().getFullYear()} Công ty TNHH TM HealthyMall. Bảo lưu mọi quyền.</p>
        <div className="flex items-center gap-4">
          <Link to="/trang/dieu-khoan-su-dung" className="text-slate-500 no-underline hover:text-brand-700">
            Điều khoản sử dụng
          </Link>
          <Link to="/trang/chinh-sach-bao-mat" className="text-slate-500 no-underline hover:text-brand-700">
            Chính sách bảo mật
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
